import { cn } from '../../lib/cn';
import type { OrganizationRow } from '../../platformadmin/framework';

type Props = { organizations?: OrganizationRow[] };

function statusColor(status: string) {
  switch (status) {
    case 'active': return 'bg-success-100 text-success-700 dark:bg-success-950 dark:text-success-300';
    case 'trial': return 'bg-brand-100 text-brand-700 dark:bg-brand-950 dark:text-brand-300';
    case 'suspended': return 'bg-error-100 text-error-700 dark:bg-error-950 dark:text-error-300';
    default: return 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400';
  }
}

export function OrganizationManagementPanel({ organizations = [] }: Props) {
  return (
    <div className="space-y-2">
      {organizations.map((o) => (
        <div key={o.name} className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 p-3 dark:border-slate-700">
          <div>
            <p className="text-sm font-medium">{o.name}</p>
            <p className="text-xs text-slate-500">{o.users} users · {o.workspaces} workspaces · {o.plan}</p>
          </div>
          <span className={cn('shrink-0 rounded-full px-2 py-0.5 text-xs font-medium capitalize', statusColor(o.status))}>
            {o.status}
          </span>
        </div>
      ))}
    </div>
  );
}
